import { useMemo } from 'react';
import { useVehiclePricing } from '~/context/vdp/UserVehicleContext';
import normalizeIncentives, {
  NormalizedIncentives
} from '~/utilities/incentives/normalizeIncentives';

export default function useIncentives(): NormalizedIncentives {
  const { price } = useVehiclePricing();

  return useMemo(() => normalizeIncentives(price), [price]);
}
